import axios from 'axios';
import { v4 as uuid } from 'uuid';
import { Constant } from '../ApiRules/ApiRules';
import store from '../store';
import { AUTH_TOKEN_EXPIRED } from '../actions/actionTypes';

const tempMeeApi = axios.create({
  baseURL: Constant.BASE_URL,
  withCredentials: true,
});

tempMeeApi.interceptors.request.use((config) => ({
  ...config,
  headers: {
    ...{ 'x-correlation-id': uuid() },
    ...config.headers,
    'x-user-agent': navigator.userAgent,
  },
}));

const getSentRefreshToken = (request) => {
  try {
    const body = typeof request.data === 'string' ? JSON.parse(request.data) : request.data;
    return (body && body.refreshToken) || null;
  } catch (e) {
    return null;
  }
};

tempMeeApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const request = error.config;

    const isRefreshEndpoint =
      request.url.includes('auth/refresh') || request.url.includes('auth-service/sessions/refresh');
    // A 401/403 from refresh ends the session, unless the stored refresh token differs from the
    // one this request sent: another tab rotated it, so its newer token must survive.
    const status = error.response && error.response.status;
    if (isRefreshEndpoint && (status === 401 || status === 403)) {
      const sentToken = getSentRefreshToken(request);
      const storedToken = localStorage.getItem('refresh_token');
      const rotatedByAnotherTab = Boolean(sentToken && storedToken && sentToken !== storedToken);
      if (!rotatedByAnotherTab) {
        store.dispatch({ type: AUTH_TOKEN_EXPIRED });
      }
    }

    return Promise.reject(error);
  },
);

export const callAuthServiceApi = async (method, url, data, params, headers) => {
  const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
  const response = await tempMeeApi({
    method,
    url: `/auth-service${normalizedUrl}`,
    data,
    params,
    headers,
  });

  return response.data;
};

export default tempMeeApi;
